import React, { ReactElement } from 'react';
import useSlideMenuCollapsedChange from '@/hooks/useSlideMenuCollapsedChange';
import './index.less';

interface propType {
  leftSpace?: number | string;
  rightSpace?: number | string;
  itemSpace?: number;
  children: ReactElement | Array<ReactElement>;
}

function DefaultFormFooter(props: propType) {
  const [initLeftSpace] = useSlideMenuCollapsedChange('', '144px');
  const { leftSpace = initLeftSpace, rightSpace, itemSpace = 15, children } = props;

  const style = {
    marginLeft: leftSpace,
    marginRight: rightSpace,
  };

  return (
    <div
      style={style}
      className={'TY_bottom-footer-btn-wrap ' + 'TY_bottom-footer-btn-wrap TY_edit-activity-footer-wrap '}
    >
      {React.Children.map(children, (ele) =>
        React.cloneElement(ele, {
          style: { marginLeft: itemSpace / 2, marginRight: itemSpace / 2 },
        })
      )}
    </div>
  );
}

export default DefaultFormFooter;
